export default "__VITE_ASSET__DPW_4BEr__"